import ReactCookies from 'react-cookies';
import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import COOKIES from '../config/cookies/cookies';
import {
  SITE_LIVINGSOCIAL_IE,
  SITE_WOWCHER,
  SITE_WOWCHERIE,
  SUGGESTEDSEARCHURL,
  UNBOXED_SUGGESTED_SEARCH_API,
} from '../config/setup/setup';
import httpCommonHeaders from './httpCommonHeaders';

export const getDefaultSuggestions = () => {
  return process.env.NEXT_PUBLIC_BRAND === SITE_LIVINGSOCIAL_IE
    ? [
        'mattress',
        'radiator cover',
        'gaming chair',
        'bed',
        'chair',
        'weighted blanket',
        'headboard',
        'blanket',
        'tablet',
      ]
    : [
        'spa',
        'bed',
        'mattress',
        'spa day',
        'city break',
        'afternoon tea',
        'holiday',
        'hotel',
        'london',
        'massage',
        'laptop',
        'sofa',
      ];
};

export const getSearchSuggestions = async (searchTerm, location) => {
  const UNBOXED_ENABLED =
    process.env.NEXT_PUBLIC_SITE === SITE_WOWCHER ||
    process.env.NEXT_PUBLIC_SITE === SITE_WOWCHERIE;

  let url;
  if (UNBOXED_ENABLED) {
    url = `${UNBOXED_SUGGESTED_SEARCH_API}?keyword=${searchTerm}&location=${location}`;
  } else {
    url = `${SUGGESTEDSEARCHURL}/${location}?keyword=${searchTerm}`;
  }
  try {
    const response = await axios({
      headers: httpCommonHeaders(),
      method: 'get',
      url,
    });

    if (response && response.data && response.data.length > 0)
      return response.data;

    return null;
  } catch {
    return null;
  }
};
